import { render, staticRenderFns } from "./pieGraph.vue?vue&type=template&id=534860ce&scoped=true"
import script from "./pieGraph.vue?vue&type=script&lang=js"
export * from "./pieGraph.vue?vue&type=script&lang=js"
import style0 from "./pieGraph.vue?vue&type=style&index=0&id=534860ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534860ce",
  null
  
)

export default component.exports